import Axios from "../utils/Axios";
import { Card } from "./tooling";

export type TodoCategory = "system" | "blocker" | "short_term";
export type Frequency = "daily" | "monthly" | "yearly";
export interface TodoInput {
  title: string;
  category: TodoCategory;
  due_date: string;
}
export interface Todo extends TodoInput {
  id: number;
  notes: string;
  position: number;
  completed: boolean;
  schedule_id: number | null;
  completed_at: string | null;
}
export interface ScheduleInput {
  title: string;
  category: TodoCategory;
  frequency: Frequency;
  start_date: string;
}
export interface TodoSchedule extends ScheduleInput {
  id: number;
  enabled: boolean;
  next_due: string;
}
export type ApprovalTodo = Card & { reviewed: boolean };
export interface TodoDashboard {
  today: string;
  todos: Todo[];
  schedules: TodoSchedule[];
  approvals: ApprovalTodo[];
}
export const getTodos = async (): Promise<TodoDashboard> =>
  (await Axios.get("/todos")).data;
export const createTodo = async (data: TodoInput) =>
  (await Axios.post("/todos", data)).data;
export const updateTodo = async (
  id: number,
  data: Partial<TodoInput> & { completed?: boolean; notes?: string }
) => (await Axios.patch(`/todos/${id}`, data)).data;
export const deleteTodo = async (id: number) =>
  (await Axios.delete(`/todos/${id}`)).data;
export const moveTodo = async (data: {
  id: number;
  category: TodoCategory;
  before_id: number | null;
}) =>
  (
    await Axios.post(`/todos/${data.id}/move`, {
      category: data.category,
      before_id: data.before_id,
    })
  ).data;
export const createSchedule = async (data: ScheduleInput) =>
  (await Axios.post("/todos/schedules", data)).data;
export const updateSchedule = async (id: number, data: { enabled: boolean }) =>
  (await Axios.patch(`/todos/schedules/${id}`, data)).data;
export const deleteSchedule = async (id: number) =>
  (await Axios.delete(`/todos/schedules/${id}`)).data;
export const reviewCard = async (card: ApprovalTodo) =>
  (
    await Axios.post(`/todos/reviews/${card.id}`, {
      version: card.version,
      reviewed: !card.reviewed,
    })
  ).data;
